import * as React from "react";

import { cn } from "#/lib/utils";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  inputClassName?: string;
  secure?: boolean;
  icon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, title, inputClassName, secure, icon, ...props }, ref) => {
    return (
      <div className={cn("relative", className)}>
        {title && (
          <label
            className={cn(
              "bg-card absolute left-[0.625rem] px-1 text-muted text-[11px] font-circular-std font-500 top-[-7px] z-[5]",
            )}
          >
            {title}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 z-10 pointer-events-none text-muted-foreground">
              {icon}
            </div>
          )}
          <input
            type={secure ? "password" : type}
            className={cn(
              "flex h-10 w-full rounded-lg border border-border bg-card px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus:border-primary focus:ring-0 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
              icon && "pl-10",
              className,
              inputClassName,
            )}
            ref={ref}
            {...props}
            value={props?.value ?? ""}
          />
        </div>
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
